import type { ExchangeKeyPatch } from '../../api/tradingTypes'

/**
 * Pure: the PATCH body for `PATCH /v3/spot/exchange/{ex}/key`.
 *
 * A field is included ONLY when the user typed a new, non-empty value.
 * Spotbot's `ExchangeKey::modifyFields()` overwrites every field PRESENT in
 * the body (B2 contract #24), so sending an untouched field as `""` would
 * wipe the stored credential. Values are sent exactly as typed — no trimming,
 * a key is opaque.
 */
export function buildExchangeKeyPatch(typed: { exchangeKey: string; exchangeSecret: string }): ExchangeKeyPatch {
  const body: ExchangeKeyPatch = {}
  if (typed.exchangeKey !== '') body.exchangeKey = typed.exchangeKey
  if (typed.exchangeSecret !== '') body.exchangeSecret = typed.exchangeSecret
  return body
}
